import React, { ChangeEvent, useCallback, useState } from 'react'
import "./ModalResumeScheduleEmail..css"
import moment, { Moment } from 'moment'
import ConfirmButton from '../../../../UIcomponents/Modals/ConfirmButton/ConfirmButton'
import { useTranslation } from 'react-i18next'
import TextOptionModalResume from './TextOptionModalResume/TextOptionModalResume'
import useGetScheduleText from '../../../../hooks/useGetScheduleText/useGetScheduleText'
import { DeviceEmail, FrecuencyEmail, TopicEmail } from '../../../../../redux/slices/components/ScheduleEmails/scheduleEmailsSlice'
import { ScheduleFrecuency } from '../../../../ScheduleNotification/CreateScheduleNotification/CreateScheduleNotificationForm/CreateScheduleNotificationForm'

export type PreviewEmail = "Mobile" | "Desktop"

type ModalResumeScheduleEmailProps = {
    frecuency: FrecuencyEmail
    subject: string
    topic: TopicEmail
    device: DeviceEmail
    schedule: ScheduleFrecuency
    bodyEmail: string
    onPreview: (type: PreviewEmail) => void
    onCloseModal: () => void
}

const ModalResumeScheduleEmail = ({
    frecuency,
    subject,
    topic,
    device,
    schedule,
    bodyEmail,
    onPreview,
    onCloseModal,
}: ModalResumeScheduleEmailProps) => {

    const { t } = useTranslation()

    const { textDate: resumeDate } = useGetScheduleText({ type: "ScheduleFrecuency", schedule: schedule, frecuencyId: frecuency.id })



    console.log("schedule", schedule)
    return (
        <div className="modal-schedule-notif-resume flex flex-d-column">
           <div className="flex flex-jc-sb">
                <p className="fs-18 fw-600">
                    {t("Emails:schedule:index:label_16")}
                </p>

                <div className="flex flex-1 flex-jc-end">

                    <TextOptionModalResume 
                        title={t("Emails:schedule:index:label_07")}
                        text={device.text}
                    />

                    <TextOptionModalResume 
                        title={t("Emails:schedule:index:label_08")}
                        text={topic.text}
                    />

                    <TextOptionModalResume 
                        title={t("Emails:schedule:index:label_09")}
                        text={frecuency.text}
                    />

                </div>
           </div>

           <div className="flex-1 flex flex-d-column flex-jc-c mb-20">
                <div className="">
                    <p className="fs-12 fw-600">
                        {subject}
                    </p>
                    <p className="fs-12 mt-14">
                        {bodyEmail}
                    </p>

                    <div className="flex mt-20">
                        <div className="">
                            <p className="fs-12 fw-700">
                                {t("Emails:schedule:index:label_17")}
                            </p>
                            <p className="fs-12 mt-10">
                                {resumeDate}
                            </p>
                        </div>

                        <div className="ml-20">
                            <p className="fs-12 fw-700">
                                {t("Emails:schedule:index:label_18")}
                            </p>
                            <p className="fs-12 mt-10">{`${moment(schedule.utcHour).format("HH:mm A")}`}</p>
                        </div>
                    </div>
                </div>
           </div>

            <div className="flex flex-d-column flex-jc-end">

                <div className="flex flex-jc-sb flex-ai-end">
                    <button
                        onClick={onCloseModal}
                        className="cancel-btn-resume-notif"
                    >
                        {t("Emails:schedule:index:label_19")}
                    </button>
                    <div className="flex flex-d-column">
                        <ConfirmButton onPress={() => onPreview("Desktop")} text={"Show desktop preview"} width="18rem" />
                        <div className="mt-8">
                            <ConfirmButton onPress={() => onPreview("Mobile")} text={"Show mobile preview"} width="18rem" />
                        </div>
                    </div>
                </div>

            </div>
            
        </div>
    )
}

export default React.memo( ModalResumeScheduleEmail )